export const patchRequestVuelidateForm = <T>(
  form: T,
  defaultValues: T,
): Partial<T> =>
  Object.keys(form).reduce((acc, field) => {
    const isChangedArray =
      form[field] !== null &&
      typeof form[field] === 'object' &&
      !(form[field] instanceof Date) &&
      (form[field].length !== defaultValues[field].length ||
        !form[field].every((v) => defaultValues[field].includes(v)));

    const isChangedValue =
      (typeof form[field] !== 'object' ||
        form[field] === null ||
        form[field] instanceof Date) &&
      form[field] !== defaultValues[field];

    if (isChangedArray || isChangedValue) acc[field] = form[field];
    return acc;
  }, {});
